module.exports = __webpack_public_path__ + "img/Slice 268@2x(4).6c08ad74.png";